import { Subscription } from 'rxjs';
import { ActivatedRoute } from '@angular/router';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { BankDepositUploadDto } from '../../../../service/dto-insurance';
import { HttpInsuranceBankDepositService } from '../../../../service/http-insurance-bank-deposit.service';

@Component({
  selector: 'app-bank-deposit-view',
  standalone: false,
  templateUrl: './bank-deposit-view.component.html',
  styleUrl: './bank-deposit-view.component.scss'
})
export class BankDepositViewComponent implements OnInit, OnDestroy {
	upload!: BankDepositUploadDto;
	loading = true;
	processing = false;
	depositId!: number;
	subscription = new Subscription();

	// columns = [
	// 	{ title: '#', property: 'lineNumber' },
	// 	{ title: 'Deposited At', ref: 'refDepositedAt' },
	// 	{ title: 'From Account', property: 'fromAccountNumber' },
	// 	{ title: 'To Account', property: 'toAccountNumber' },
	// 	{ title: 'Deposit Amount', property: 'depositAmount' },
	// 	{ title: 'Allocated Amount', property: 'allocatedAmount' },
	// 	{ title: 'Remaining Amount', ref: 'remainingAmount' },
	// 	{ title: 'Reference', property: 'reference' },
	// 	{ title: 'Status', ref: 'refStatus' },
	// 	{ title: 'Failure Reason', ref: 'refFailureReason' },
	// ];

	constructor(
		private route: ActivatedRoute,
		private bankDepositService: HttpInsuranceBankDepositService) {

	}

	ngOnInit(): void {
		this.subscription.add(this.route.paramMap.subscribe(paramMap => {
			this.depositId = +paramMap.get('id')!;
			this.fetchUpload();
		}));
	}
	ngOnDestroy(): void {
		this.subscription.unsubscribe();
	}
	fetchUpload(): void {
		this.loading = true;
		this.bankDepositService.get(this.depositId).subscribe({
			next: (res) => {
				this.upload = res;
				this.loading = false;
			},
			error: () => {
				this.loading = false;
			},
		});
	}
}
